import { WeaTools } from 'ecCom'

export const getFormField = (params) => {
    return  WeaTools.callApi('/api/hrm/login/getBindTokenKeyForm','GET',params);
}

export const saveFormFields = (params) => {
    return  WeaTools.callApi('/api/hrm/login/saveBindTokenKey','POST',params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/bindtokenkey.js